<template>
  <div class="earnWithUpskill">
    <Earnwithupskillupdate class="space_y_50" />
    <Bannerui
      title="What is Upskill?"
      subtitle="Upskill is a skill-sharing platform for individuals and organizations where domain experts share their skills."
      cent="relative-text-center"
      :bg="heroData.image"
      :mb_bg="heroData.image_mb"
      fonts="font_24"
      class="space_y_76 space_y_100_down"
    />
    <Grid_4_banner title="Why Teach with Upskill?" class="space_y_100_down" />
    <!-- <app-earnWithUpskill></app-earnWithUpskill> -->
    <Bannerui
      title="What is Upskill?"
      subtitle="Although Upskill does not require formal teaching credentials, to be a trainer, you have to be a domain expert in any particular field with a credible track record. Our preferred learning paths are Coding, UX/UI, Data Science, Project Management, Tech Business etc."
      cent="relative-text-left"
      :bg="heroData1.image"
      :mb_bg="heroData1.image_mb"
      class="space_y_100_down"
      fonts="font_20"
    />
    <Home-trainers-saying />
    <Questions
      title="I have other questions!"
      subtitle="Reach out to us through the contacts given below if you can't find your answers here. Join our Facebook group and get connected with us to know about all the exciting new updates."
      Color="#0B2A5A"
    />
  </div>
</template>

<script>
import Grid_4_banner from '../components/earnWithUpskill/grid_4_banner..vue'
import Bannerui from '../components/earnWithUpskill/bannerui.vue'
// import earnWithUpskill from '../components/earnWithUpskill/earnWithUpskill'
import Earnwithupskillupdate from '../components/earnWithUpskill/earnwithupskillupdate.vue'
import Questions from '../components/earnWithUpskill/questions'
import HomeTrainersSaying from '../components/home/home-trainers-saying.vue'
export default {
  name: 'earnWithUpskill',
  data() {
    return {
      heroData: {
        mobile: 'course-hero-mobile',
        image: require('../assets/images/wes-hicks-4-EeTnaC1S4-unsplash.png'),
        image_mb: require('../assets/images/wes-hicks-4-EeTnaC1S4.png'),
      },
      heroData1: {
        mobile: 'course-hero-mobile',
        image: require('../assets/images/OT134C1.png'),
        image_mb: require('../assets/images/OT134C12_mobile.png'),
      },
    }
  },
  components: {
    // appEarnWithUpskill: earnWithUpskill,
    Earnwithupskillupdate,
    Questions,
    HomeTrainersSaying,
    Bannerui,
    Grid_4_banner,
  },
  created() {
    this.Loaded()
  },
}
</script>
